const DEFAULT_CONFIG = {
  news: {
    youtubeUrl: "",
    defaultArticleImageUrl: "",
  },
  learningSuite: {
    url: "",
  },
  tools: {
    amainvoice: {
      url: "",
      showcaseUrl: "",
      supportsIframe: false,
    },
    billbee: {
      url: "",
      showcaseUrl: "",
      supportsIframe: false,
    },
    replyco: {
      url: "",
      showcaseUrl: "",
      supportsIframe: false,
    },
    ventoryOne: {
      url: "",
      showcaseUrl: "",
      supportsIframe: false,
    },
  },
  google: {
    clientId: "",
    redirectUri: "",
    scope: "openid email profile",
  },
  segment: {
    writeKey: "",
    enabled: false,
  },
  appEnv: "",
  isDev: false,
  isProd: false,
  isComrceStaging: false,
  isStaging: false,
};

const TOOL_KEYS = ["amainvoice", "billbee", "replyco", "ventoryOne"];

export let env = withDefaults();

function withDefaults(config = {}) {
  return {
    ...DEFAULT_CONFIG,
    ...config,
    news: {
      ...DEFAULT_CONFIG.news,
      ...(config?.news ?? {}),
    },
    learningSuite: {
      ...DEFAULT_CONFIG.learningSuite,
      ...(config?.learningSuite ?? {}),
    },
    tools: Object.fromEntries(
      TOOL_KEYS.map((key) => [
        key,
        {
          ...DEFAULT_CONFIG.tools[key],
          ...(config?.tools?.[key] ?? {}),
        },
      ]),
    ),
    google: {
      ...DEFAULT_CONFIG.google,
      ...(config?.google ?? {}),
    },
    segment: {
      ...DEFAULT_CONFIG.segment,
      ...(config?.segment ?? {}),
    },
    isDev: Boolean(config?.isDev),
    isProd: Boolean(config?.isProd),
    isComrceStaging: Boolean(config?.isComrceStaging),
    isStaging: Boolean(config?.isStaging),
  };
}

async function fetchRuntimeConfig() {
  const response = await fetch("/api/__config", {
    cache: "no-store",
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to load runtime config: ${response.status}`);
  }

  return response.json();
}

export async function loadEnv() {
  const config = await fetchRuntimeConfig();
  env = withDefaults(config);
  return env;
}

export async function reloadEnv() {
  return loadEnv();
}

export function getLandingPageConfig(t) {
  return {
    url: t("configuration.landing_page.url"),
    supportsIframe: translatedBoolean(
      t,
      "configuration.landing_page.supportsIframe",
    ),
  };
}
function translatedBoolean(t, key) {
  return String(t(key)).trim().toLowerCase() === "true";
}
